import { ANY_EXTERNAL_RESOURCE_ID, ANY_INTERNAL_RESOURCE_ID, ANY_RESOURCE_ID } from 'constants/anyResourceId'
import { Resource } from 'types'

/** Matches any string but does preserve autocompletion of predefined string literals */
type ArbitraryString = string & { anyString?: any }

const everyResourceFilter = () => true

export const filterByInternalResource = (resource: Pick<Resource, 'type'>) =>
  resource.type === 'FITTER_INTERNAL' || resource.type === 'CABIN'

export const filterByExternalResource = (resource: Pick<Resource, 'type'>) => resource.type === 'FITTER' || resource.type === 'CABIN'

/**
 * Filters resources based on the provided resourceId, which can be a specific resource ID or a special "any" ID.
 * - If resourceId is ANY_RESOURCE_ID, all resources are included.
 * - If resourceId is ANY_INTERNAL_RESOURCE_ID, resources of type 'FITTER_INTERNAL' or 'CABIN' are included.
 * - If resourceId is ANY_EXTERNAL_RESOURCE_ID, resources of type 'FITTER' or 'CABIN' are included.
 * - Otherwise, only the resource with the matching ID, and all cabins are included.
 * @param resourceId
 * @returns Filter function that can be used to filter an array of resources
 */
export function filterByResource(
  resourceId:
    | typeof ANY_RESOURCE_ID
    | typeof ANY_EXTERNAL_RESOURCE_ID
    | typeof ANY_INTERNAL_RESOURCE_ID
    | ArbitraryString
    | null
    | undefined
): (resource: Pick<Resource, 'id' | 'type'>) => boolean {
  if (!resourceId) {
    return everyResourceFilter
  } else if (resourceId === ANY_RESOURCE_ID) {
    return everyResourceFilter
  } else if (resourceId === ANY_INTERNAL_RESOURCE_ID) {
    return filterByInternalResource
  } else if (resourceId === ANY_EXTERNAL_RESOURCE_ID) {
    return filterByExternalResource
  } else {
    const filterBySpecificResource = (resource: Pick<Resource, 'id' | 'type'>) => resource.id === resourceId || resource.type === 'CABIN'
    return filterBySpecificResource
  }
}
